export var MINUTE_MS = 60 * 1000;
export var HOUR_MS = MINUTE_MS * 60;
export var DAY_MS = HOUR_MS * 24;
export var ISO_8601_DATE_FORMAT = 'yyyy-MM-dd';
export var SECONDS_TIMESTAMP_FORMAT = 't';
export var DAYS_OF_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];